"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iterableSplitWith = iterableSplitWith;

var _spliterator = require("../../../internal/spliterator");

class PredicateSpliterator extends _spliterator.Spliterator {
  constructor(sourceIterator, predicate) {
    super(sourceIterator);
    this.predicate = predicate;
    this.item = null;
    this.idx = 0;
  }

  static nullOrInstance(sourceIterator, predicate) {
    const inst = new PredicateSpliterator(sourceIterator, predicate);
    return inst._isEmpty() ? null : inst;
  }

  _isEmpty() {
    this.item = super.next();
    return this.item.done;
  }

  next() {
    if (this.item === null) {
      this.item = super.next();
    }

    if (this.item.done) {
      return {
        value: undefined,
        done: true
      };
    } else {
      const {
        value
      } = this.item;
      const shouldSplit = this.predicate(value, this.idx++);
      this.item = null;
      return {
        value: shouldSplit ? _spliterator.split : value,
        done: false
      };
    }
  }

}

function* iterableSplitWith(source, predicate) {
  yield* new _spliterator.PartsIterator(PredicateSpliterator.nullOrInstance(source[Symbol.iterator](), predicate));
}